import { useLocation, useNavigate } from 'react-router'

import { routeName } from '~/@common/constants'
import { commonRepo } from '~/@common/services/repo.service'
import IconButton from '~/@common/ui/(Button)/IconButton/IconButton'

const NotificationButton = ({ size, iconSize }: { size: number; iconSize: number }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // NOTIFICATION_CENTER restriction 차단 시 미노출
  if (!commonRepo.permission.byFeature.isAllowed('NOTIFICATION_CENTER')) return null

  const isNotificationPage = location.pathname === routeName.notification
  return (
    <IconButton
      name="icon_notification"
      aria-label="알림"
      aria-current={isNotificationPage ? 'page' : undefined}
      iconSize={iconSize}
      iconStyle={{
        color: isNotificationPage ? 'var(--Colors-Blue-600)' : 'var(--Colors-Gray-600)',
      }}
      style={{
        width: size,
        height: size,
        borderRadius: 'var(--Radius-200)',
        border: isNotificationPage
          ? `1px solid rgba(57, 95, 226, 0.20)`
          : `1px solid var(--Colors-Gray-300)`,
        backgroundColor: isNotificationPage ? 'rgba(57, 95, 226, 0.05)' : 'var(--White)',
        flexShrink: 0,
      }}
      onClick={() => {
        navigate(routeName.notification)
      }}
    />
  )
}

export default NotificationButton
